import type { CustomerConsultationSummary } from '@/stores/customerConsultationsHub'

export type PayDueCheckoutKind = 'noshow' | 'settlement'

/** Unpaid no-show fee on the hub DTO (`kind: 'noshow_fee'` with no `at`). */
export function hasUnpaidNoshowFee(summary: CustomerConsultationSummary): boolean {
  return summary.payment.lines.some((line) => line.kind === 'noshow_fee' && line.at == null)
}

export function resolvePayDueCheckoutKind(
  summary: CustomerConsultationSummary,
): PayDueCheckoutKind {
  return hasUnpaidNoshowFee(summary) ? 'noshow' : 'settlement'
}

function isEarlyCanvasNoShow(summary: CustomerConsultationSummary): boolean {
  if (summary.cancellationReason !== 'canvas_no_show') {
    return false
  }
  const { scheduledStart, cancelledAt } = summary
  if (!scheduledStart || !cancelledAt) {
    return false
  }
  return new Date(cancelledAt).getTime() < new Date(scheduledStart).getTime()
}

/** Chip override for unpaid no-show fee rows (uiStatus stays payment_due). */
/** PAD-FEE: late cancellation vs no-show label for unpaid `noshow_fee` rows. */
export function resolveUnpaidNoshowFeeDisplayName(
  summary: CustomerConsultationSummary,
  catalogNoshowFeeName: string | null,
): string {
  const chipStatus = displayUiStatusForUnpaidNoshowFeeChip(summary)
  if (chipStatus === 'no_show') {
    return catalogNoshowFeeName ?? 'No-show fee'
  }
  if (chipStatus === 'cancelled') {
    return 'Late cancellation fee'
  }
  return catalogNoshowFeeName ?? 'Fee'
}

export function displayUiStatusForUnpaidNoshowFeeChip(
  summary: CustomerConsultationSummary,
): CustomerConsultationSummary['uiStatus'] | undefined {
  if (!hasUnpaidNoshowFee(summary)) {
    return undefined
  }
  if (summary.cancellationReason === 'canvas_no_show' && !isEarlyCanvasNoShow(summary)) {
    return 'no_show'
  }
  return 'cancelled'
}
